// broiler.batches.detail — one canonical /broiler/batches/<batch-name> record.
//
// The page resolves its row from broiler.batches.hub's repaired ppp-v4 array,
// not BatchesContext. It still mounts BatchForm, whose complete daily history
// is independently owned by broiler.batchForm.dailys. The page publishes the
// hub result to BatchesContext only for App's retained form/write closures; the
// route renderer never reads that mirror back.

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'broiler.batches.detail',
  obligations: Object.freeze([
    Object.freeze({id: 'broiler.batches.hub', owner: 'permanent'}),
    Object.freeze({id: 'broiler.batchForm.dailys', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
